export const scoreMapList = [
    { name: '沟通表达', prop: 'comCommunication' },
    { name: '逻辑思维', prop: 'comLogical' },
    { name: '学习能力', prop: 'comLearning' },
    { name: '抗压力', prop: 'comCrush' },
    { name: '执行力', prop: 'comExecutive' },
    { name: '应变', prop: 'comStrain' },
    { name: '亲和力', prop: 'perAffinity' },
    { name: '踏实度', prop: 'perSolid' },
    { name: '外向性', prop: 'perExtroversion' }
]

export const otherMapList = [
    { name: '热爱度与平台认可度', prop: 'otherRecognition', required: true },
    { name: '职业规划', prop: 'otherCareerPlan', required: true },
    { name: '家庭情况', prop: 'otherFamilyInfo', required: true },
    { name: '其他加分项', prop: 'otherInfo', required: false },
]

export const skillMapList = [
    { name: '项目管理', prop: 'professionalProjMgr', placeholder: '（重点考察：计划制定、进度跟进、风险管理、干系人管理、团队配合情况等）' },
    { name: '美术背景', prop: 'professionalArt', placeholder: '（重点考察：绘画、MAX/Maya、视频剪辑等美术相关功底；美术外包管理经验、影视动画管理经验）' }
]

function getProps(list, initVal = '') {
    return list.reduce((ret, next) => (ret[next.prop] = initVal, ret), {})
}

export const scoreProp = getProps(scoreMapList)
export const otherProp = getProps(otherMapList)
export const skillProp = getProps(skillMapList)



// WEBPACK FOOTER //
// ./src/views/evaluation/libs.js